<template>
  <div>
    <VueScriptComponent script='<script type="text/javascript" src="//sites.yext.com/292857-reviews.js"></script>' />
    <div :class="{ alt: !isHomePage }" class="form">
      <h2 v-if="settings && settings.heading">{{ settings.heading }}</h2>
      <div class="inner">
        <div class="form-head">
          <p v-if="settings && settings.paragraph">{{ settings.paragraph }}</p>
          <a
        :href="'tel:' + settings.branches[0].telephone"
        class="contacticon"
        v-if="settings && settings.branches && settings.branches.length && settings.branches[0].telephone"
      >
        <i class="fa fa-phone"></i>
        <span>{{settings.branches[0].telephone}}</span>
      </a>
      <a
        :href="'mailto:' + settings.branches[0].email"
        class="contacticon"
        v-if="settings && settings.branches && settings.branches.length && settings.branches[0].email"
      >
        <i class="fa fa-envelope"></i>
        <span>{{settings.branches[0].email}}</span>
      </a>
        </div>

        <iframe
          title="Our office"
          allowfullscreen
          class="embed"
          frameborder="0"
          height="500"
          src="https://www.google.com/maps/embed?pb=!4v1525857799088!6m8!1m7!1sCAoSLEFGMVFpcE5rRnI3RkFnaG9lWDdGQmd6ZmpQanRKbnZHRTgwd2hUWG95Z2Fz!2m2!1d53.129201505886!2d-1.258771746712!3f316.5!4f0!5f0.7820865974627469"
          style="border:0"
          v-if="isHomePage"
          width="100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import VueScriptComponent from "vue-script-component"
import { mapState, mapGetters } from "vuex"
import api from "@/services/api"
import VueRecaptcha from "vue-recaptcha"

export default {
  name: "ContactForm",
  components: {
    VueScriptComponent,
    VueRecaptcha
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["isHomePage"])
  },
  data: function() {
    return {
      emailsuccess: false,
      emailerror: false,
      errormessage: "",
      form: {},
      initial_values: {}
    }
  },
  created: function() {
    this.form = JSON.parse(JSON.stringify(this.initial_values))
  },
  methods: {
    sendEmail: function() {
      this.emailsuccess = false
      this.emailerror = false

      if (!this.form.name || !this.form.email || !this.form.message) {
        this.errormessage = "Please fill in all fields, thanks!"
        this.emailerror = true
        return false
      }

      this.$refs.recaptcha.execute()
    },
    onCaptchaVerified: function(recaptchaToken) {
      const self = this
      self.status = "submitting"
      self.$refs.recaptcha.reset()

      var content = `The following message has been sent from the website:<br /><br />`

      content += `Name: ${this.form.name}<br />
                  Email: ${this.form.email}<br />`

      if (this.form.tel) content += `Telephone: ${this.form.tel}<br />`
      if (this.form.company) content += `Company: ${this.form.company}<br />`
      content += `Message: ${this.form.message}<br />`

      api
        .verifyCaptcha(recaptchaToken)
        .then(res => {
          if (res.status == 200)
            api
              .sendEmail("Enquiry from the website", content)
              .then(() => {
                this.emailsuccess = true
                this.form = JSON.parse(JSON.stringify(this.initial_values))
              })
              .catch(() => {
                this.errormessage = "There has been an error submiting your message"
                this.emailerror = true
              })
        })
        .catch(() => {
          this.errormessage = "There has been an error submiting your message"
          this.emailerror = true
        })
    },
    onCaptchaExpired: function() {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style scoped>
.form {
  text-align: center;
  padding-bottom: 6rem;
}

.form.alt {
  background: #f5f5f5;
}

.form-head {
  text-align: center;
  padding: 3rem 3% 0.5rem 3%;
}

.spacer {
  width: 25rem;
  margin-top: 5rem;
}

.form.alt .form-head {
  padding-top: 2rem;
}

.form h2 {
  font-weight: normal;
  color: #bb9765;
  font-size: 3rem;
  padding-top: 6rem;
  font-family: "Merriweather", serif;
}

.txt {
  border: 0;
  width: 48%;
  margin: 1rem 0;
  padding: 1rem 1.5rem;
  font-size: 1.5rem;
  border: 3px solid #f5f5f5;
}

.txt:first-child {
  margin-right: 4%;
}

.contacticon {
  font-size: 2.5rem;
  display: inline-block;
  padding:2rem;
  color:#bb9765;
  white-space: nowrap;
}

.contacticon span {
  margin-left: 2rem;
  color:#231f20
}

textarea.txt {
  width: 100%;
  margin: 1rem 0%;
  height: 8rem;
  margin-right: 0 !important;
}

.embed {
  margin-top: 6rem;
}

button {
  display: inline-block;
  background: #231f20;
  padding: 1rem 2rem;
  margin-top: 1rem;
  line-height: 1.8;
  font-size: 1.5rem;
  border: 0;
  color: white;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}

button i {
  margin-left: 0.5rem;
}

.success,
.error {
  clear: both;
  display: block;
}

.success {
  color: green;
  display: block;
}

.error {
  color: #cc0000;
}


@media screen and (max-width: 800px) {
.contacticon {
  font-size: 2rem;
  padding: 1rem 0;
  display: block;
}
}
</style>
